import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { QueryFilterService } from "../../core/services/query-filter-service";
import { Observable } from "rxjs";
import { globals } from "../../globals";
import { IGridifyQuery } from "gridify-client";
import { TipoSituacaoCadastral } from "../../dominio/enums";
import { PaginatedModel } from "../../dominio/paginated-model";
import { GiLojaModel } from "../../dominio/gi-loja-model";

export class LojaGetOneResponse {
  result: GiLojaModel;
}

export class LojaGetManyResponse {
  results: GiLojaModel[];
  pagination: PaginatedModel
}

export class LojaCreationRequest {
  nome: string;
  icone: string;
  situacao: TipoSituacaoCadastral;
}

export class LojaUpdateRequest {
  id: number;
  nome: string;
  icone: string;
  situacao: TipoSituacaoCadastral;
}

@Injectable({
  providedIn: 'root'
})
export class LojaConfigService {
  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService
  ) {
  }

  buscarPorId(idLoja: number): Observable<LojaGetOneResponse>{
    return this.http.get<LojaGetOneResponse>(`${globals.apiUrl}/api/v2/core/config/lojas/${idLoja}`);
  }

  buscarTodos(queryFilter: IGridifyQuery | null = null): Observable<LojaGetManyResponse>{
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<LojaGetManyResponse>(`${globals.apiUrl}/api/v2/core/config/lojas`, { params });
  }

  cadastrar(data: LojaCreationRequest): Observable<LojaGetOneResponse>{
    return this.http.post<LojaGetOneResponse>(
      `${globals.apiUrl}/api/v2/core/config/lojas`,
      data
    );
  }

  atualizar(idLoja: number, data: LojaUpdateRequest): Observable<LojaGetOneResponse>{
    return this.http.put<LojaGetOneResponse>(
      `${globals.apiUrl}/api/v2/core/config/lojas/${idLoja}`,
      data
    );
  }

  excluir(idLoja: number): Observable<void>{
    return this.http.delete<void>(
      `${globals.apiUrl}/api/v2/core/config/lojas/${idLoja}`
    );
  }
}
